import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    checkIssueDate:
      'It dates back to less than three months (issued after {earliestIssueDate})',
    checkMessage:
      'Please help us validate your account faster by checking your document one last time',
  },
  fr: {
    checkIssueDate:
      'Votre document est daté de moins de 3 mois (émis après le {earliestIssueDate})',
    checkMessage:
      'Pour nous aider à valider votre compte plus rapidement, prenez quelques minutes pour vérifier une dernière fois votre document.',
  },
});
